import AddServiceManage from "models/add-service-manage";
import { formaTimeToMinute } from "common/js/util";
export default {
  data() {
    return {
      // 增值服务维护列表
      addServiceMaintenanceList: [],
      // 已开启的增值服务列表
      openAddServiceList: [],
    }
  },
  created() {
  },
  methods: {
    // 获取增值服务维护列表数据
    initAddServiceList(params = {}) {
      AddServiceManage.getAddServiceList(params).then(res => {
        if (res.success) {
          let arr = [];
          let openList = [];
          res.result.map((value, index) => {
            let obj = {};
            obj.id = value.id;
            obj.keyword = value.keyword;
            obj.sort = index + 1 < 10 ? `0${index + 1}` : index + 1;
            obj.name = value.name;
            obj.status = value.status;
            obj.createTime = value.createTime ? formaTimeToMinute(value.createTime) : '/';
            arr.push(obj);
            if (value.status) openList.push(obj);
          });
          this.addServiceMaintenanceList = arr;
          this.openAddServiceList = openList;
        } else {
          this.$message.error(res.message)
        }
      });
    }
  }
}